import { css } from '@emotion/react';
import { gray_tertiary, pink_primary, white } from 'styles';

/**
 * 작성 가능한 리뷰, 작성한 리뷰 페이지에서 사용되는 공통 스타일 정의
 * @description
 */
export const review_page_common_style = css`
  height: 100%;
  background: ${white};

  .text_info {
    background: ${white};
    display: flex;
    justify-content: space-between;
    padding: 14px 16px 10px;

    .review_count {
      color: ${gray_tertiary};
      padding-left: 4px;
    }
    .point > label {
      color: ${pink_primary};
    }
  }
  .review_list {
    padding: 0 16px;
    background: ${white};
  }
`;

export const card_container_style = css`
  background: ${white};
  display: flex;

  .thumbnail {
    min-width: 64px;
    height: 64px;

    span {
      &:before {
        background: #00000008;
        position: absolute;
        width: 64px;
        height: 64px;
        content: '';
        z-index: 1;
      }
    }
    img {
      border-radius: 4px;
    }
  }
`;

export const card_section_style = css`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;

  .product_name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &.reviewable {
      -webkit-line-clamp: 3;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }

  .product_options {
    margin: 2px 0 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &.reviewable {
      -webkit-line-clamp: 2;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
`;
